import React from 'react'
import { UncontrolledPopover, PopoverBody } from 'reactstrap';

export default function CardData(props) {
  const accent = props.color || '#6366f1'
  const popoverId = props.idCard != null ? `md-kpi-pop-${props.idCard}` : 'md-kpi-pop-default'

  return (
    <div
      className={`md-card md-card--kpi ${props.className || ''}`}
      style={{ '--md-accent': accent, color: accent }}
    >
      <div className="md-card__glow" aria-hidden />
      <div className="md-card__kpi-head">
        <h4 className="md-card__kpi-title">{props.title}</h4>
        <button
          type="button"
          id={popoverId}
          className="md-card__info-btn"
          aria-label="Ayuda"
        >
          <i className="fas fa-info-circle" />
        </button>
      </div>
      <UncontrolledPopover trigger="legacy" placement="bottom" target={popoverId}>
        <PopoverBody className="p-0">
          <div className="dashboard-poppover md-popover-img" style={props.text2}>
            <img src={props.text1} alt="" />
          </div>
        </PopoverBody>
      </UncontrolledPopover>
      {props.circle ? (
        <p className="md-card__kpi-value md-card__kpi-value--ring">{props.value}%</p>
      ) : (
        <p className="md-card__kpi-value">{props.value}</p>
      )}
    </div>
  )
}
